/**
 * Trang danh sách BĐS yêu thích của người dùng đã đăng nhập.
 *
 * Luồng dữ liệu:
 * - useFavoriteProperties tải danh sách favorite từ API.
 * - Trích xuất object property từ mỗi favorite item để render PropertyCard.
 * - Hiển thị skeleton khi đang tải; EmptyState khi không có mục nào.
 */
import { Link } from 'react-router-dom';
import { EmptyState } from '../../components/Common/EmptyState';
import { PropertyCard } from '../../components/property/PropertyCard';
import { PropertyCardSkeletonGrid } from '../../components/property/PropertyCardSkeleton';
import { useFavoriteProperties } from '../../features/favorites/hooks/useFavoriteProperties';
import { APP_ROUTES } from '../../shared/constants/routes';
import { TEXT } from '../../shared/languages';

/** Trang hiển thị grid các BĐS đã lưu yêu thích */
export const FavoritesPage = () => {
  const { favoriteItems, isLoadingFavorites } = useFavoriteProperties();
  const t = TEXT.favorites;
  /** Lọc bỏ item không có property (dữ liệu lỗi/thiếu) */
  const properties = favoriteItems
    .map((item) => item.property)
    .filter(Boolean);

  return (
    <section className="section section-favorites">
      <div className="container">
        <div className="favorites-page-header">
          <h1>{t.title}</h1>
          {properties.length > 0 && (
            <Link to={APP_ROUTES.home} className="text-link">
              {t.browseMore}
            </Link>
          )}
        </div>

        {isLoadingFavorites ? (
          <PropertyCardSkeletonGrid count={4} />
        ) : properties.length ? (
          <div className="property-grid">
            {properties.map((property) => (
              <PropertyCard key={property.id} property={property} />
            ))}
          </div>
        ) : (
          <EmptyState
            title={t.emptyTitle}
            message={t.emptyMessage}
            action={<Link to={APP_ROUTES.home} className="button">{t.findProperties}</Link>}
          />
        )}
      </div>
    </section>
  );
};
